import styled from 'styled-components';
import { MediaQuery } from '../../../../constants/Styles';

export const MenuContainer = styled.div`
  display: flex;
  gap: 13px;
`;

export const SectionWrapper = styled.div`
  display: flex;
`;

export const MoreButtonWrapper = styled.div`
  padding: 10px 30px;

  ${MediaQuery.XL_AND_DOWN} {
    padding: 0 10px 30px 10px;
  }
`;
